import React from "react";
import classes from "./BurgerIngredient.module.css";

function Paneer() {
  return <div className={classes.Paneer}></div>;
}

export default Paneer;
